import {
  compose,
  css,
  ResponsiveValue,
  space,
  SpaceProps,
  variant,
} from '@wrisk/styled-system'
import styled from 'styled-components'

import { withDefaultProps } from '../../defaultProps'
import { Image } from '../images'
import { Box, lgBumps } from '../layout'

export type PromotionBannerContainerProperty = 'default' | 'narrow'

export interface PromotionBannerContainerProps extends SpaceProps {
  variant?: ResponsiveValue<PromotionBannerContainerProperty>
  backgroundImage?: string
}

const defaultProps = withDefaultProps<PromotionBannerContainerProps>({
  variant: 'default',
})

export const PromotionBannerContainer = styled.div.attrs<PromotionBannerContainerProps>(
  defaultProps,
)(
  ({ backgroundImage }) =>
    css({
      color: 'foregroundPromoBanner',
      backgroundColor: 'backgroundPromoBanner',
      backgroundImage: backgroundImage ? `url('${backgroundImage}')` : undefined,
      backgroundSize: 'cover',
      backgroundPosition: '0px 0px',
      borderRadius: 2,
      p: lgBumps,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'relative',
    }),
  variant({
    scale: 'PromotionBannerContainer',
    variants: {
      default: {
        [Box]: {
          maxWidth: ['100%', '100%', '400px', '500px'],
        },
        [Image]: {
          display: ['none', 'none', 'block'],
          width: ['200px', '200px', '300px', '400px'],
          bottom: [0, 0, '-32px', '-48px'],
          position: 'absolute',
          right: 0,
        },
      },
      narrow: {
        [Box]: {
          maxWidth: '420px',
        },
        [Image]: {
          display: ['none', 'none', 'none', 'block'],
          width: ['200px', '200px', '200px', '260px', '300px'],
          bottom: [0, 0, '-16px', '-24px'],
          position: 'absolute',
          right: 0,
        },
      },
    },
  }),
  compose(space),
)
